<template>
  <div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <template v-if="!loading">
      <div v-if="task">
        <p class="text-muted">{{ printDate(task.created_at) }}
          <button v-if="task.is_active" @click="getRequest" class="btn btn-info btn-xs"><i
            class="icon-fa icon-fa-refresh"></i></button>
        </p>
        <p v-for="c in task.task_data">{{ c.number.substr(c.number.length - 4) }}: <strong>{{ c.amount }}</strong></p>
        <p>Всего: <strong>{{ totalAmount }}</strong></p>
      </div>
      <LoadingButton
        v-if="!requestSent && !task"
        title="Собрать баланс карт (≈ 3 мин)"
        :loading="btnLoading"
        :color="$constants.PRIMARY_COLOR"
        :onClick="() => collectBalance()"
        className="btn btn-outline-info btn-xs"
      />
    </template>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  props: ['date'],
  components: {
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      taskType: 15,
      totalAmount: 0,
      task: null,
      btnLoading: false,
      requestSent: false,
      collectRequest: null,
    }
  },
  created() {
    this.getRequest();
  },
  methods: {
    async getRequest() {
      this.loading = true;
      const {data} = await api.post('/tasks/search', {
        type_id: this.taskType,
        date: this.date,
        single: true
      });
      if (data.success) {
        if (data.records) {
          this.task = data.records;
          this.totalAmount = data.records.task_data.reduce((acc, c) => acc + +(c.amount || 0), 0)
        }
      } else {
        toastr['warning'](data.message || 'Ошибка получения задач');
      }
      this.loading = false;
    },
    async collectBalance() {
      this.btnLoading = true;
      const {data} = await api.post('/tasks/new', {
        type: 'balanceCollectBySms',
        cardsUseTypes: [2, 3],
      });
      if (data.success) {
        toastr['success']('Задача создана', 'Успешно');
        this.requestSent = true;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.btnLoading = false;
    },
  }
}

</script>

<style scoped>
p {
  margin-bottom: 0;
  font-size: 14px;
  text-align: right;
}
</style>
